import styled from "styled-components";

export const StyledUrlImage = styled.img`
  max-width: 140px;
  height: fit-content;
  max-height: 50px;
`;